export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14799.64a359d7.jpg";